var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-title-bar-scroll-page',{ref:"container",attrs:{"title":"视频播放"}},[_c('video',{staticStyle:{"width":"100%","max-height":"93vh"},attrs:{"src":_vm.videoUrl,"autoplay":"","controls":"","poster":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }